import { PrimevalLegacy } from '@apeiron/planet'
import { createStrictContext } from '@apeiron/temp'
import useFetchPlanetPrimevalJson from '@src/hooks/json/useFetchPlanetPrimevalJson'
import React, { useMemo } from 'react'

const [ContextProvider, usePrimevalLegacyContext] =
  createStrictContext<PrimevalLegacyContextValue>('PrimevalLegacy')

export { usePrimevalLegacyContext }
export const PrimevalLegacyProvider: React.FC<Props> = props => {
  const { children } = props

  const { data: primevalLegacyData } = useFetchPlanetPrimevalJson()

  const primevalLegacyContextValue = useMemo<PrimevalLegacyContextValue>(() => {
    return {
      getPrimevalLegacy(PrimevalLegacyId: number) {
        return primevalLegacyData?.find(
          data => data.id === PrimevalLegacyId.toString()
        )
      }
    }
  }, [primevalLegacyData])

  return (
    <ContextProvider value={primevalLegacyContextValue}>
      {children}
    </ContextProvider>
  )
}

export type PrimevalLegacyContextValue = {
  getPrimevalLegacy: (PrimevalLegacyId: number) => PrimevalLegacy | undefined
}

export type Props = {
  children: React.ReactNode
}
